import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';
import type { SkillInput } from '@/typings/models/Skill';

export function fetchSkillsRequest() {
  return request(PATHS.FETCH_SKILLS, { method: 'GET' });
}

export function createSkillRequest(data: SkillInput) {
  return request(PATHS.CREATE_SKILL, { method: 'POST', data });
}

export function updateSkillRequest(skillId: string, data: SkillInput) {
  return request(URLParamBuilder(PATHS.UPDATE_SKILL, { params: { skillId } }), {
    method: 'PATCH',
    data,
  });
}

export function deleteSkillRequest(skillId: string) {
  return request(URLParamBuilder(PATHS.DELETE_SKILL, { params: { skillId } }), {
    method: 'DELETE',
  });
}
